import { PureComponent } from 'react';
import classNames from 'classnames';
import { PropertyExplorerCobranding as theme } from 'legacy/css-modules';
import { Button } from 'legacy/components/Button';

class PropertyExplorerCobranding extends PureComponent {
  state = {
    expanded: false
  };

  handleToggleExpand = () => {
    this.setState({
      expanded: !this.state.expanded
    });
  };

  render() {
    const { cobrandingData, isMobile } = this.props;
    const { expanded } = this.state;
    return (
      <div data-hc-name="cobrand-section">
        <div className="flex-row">
          {cobrandingData.photoUrl && cobrandingData.includePhoto && (
            <div className={theme['section']}>
              <div className={theme['user-photo']}>
                <img
                  className={theme['user-photo--image']}
                  alt="User branding photo"
                  src={cobrandingData.photoUrl}
                />
              </div>
            </div>
          )}
          <div
            className={classNames(
              theme['section'],
              theme['info-section'],
              'flex-item'
            )}
          >
            {(cobrandingData.firstName || cobrandingData.lastName) &&
              cobrandingData.includeName && (
                <div>
                  <div
                    className={theme['user-name']}
                    data-hc-name="cobrand-fullname-text"
                  >
                    {cobrandingData.fullName}
                  </div>
                </div>
              )}
            {cobrandingData.companyName && cobrandingData.includeCompanyName && (
              <div
                className={theme['company-name']}
                data-hc-name="cobrand-companyname-text"
              >
                {cobrandingData.companyName}
              </div>
            )}

            {!expanded && (
              <div
                className={theme['expand-button']}
                onClick={this.handleToggleExpand}
                data-hc-name="cobrand-expand-button"
              >
                <div className={theme['expand-dot']} />
                <div className={theme['expand-dot']} />
                <div className={theme['expand-dot']} />
              </div>
            )}
            {expanded && (
              <div
                className={theme['extended-info']}
                data-hc-name="cobrand-expanded-section"
              >
                {cobrandingData.addressLine1 &&
                  cobrandingData.includeAddressLine1 && (
                    <div>{cobrandingData.addressLine1}</div>
                  )}
                {cobrandingData.addressLine2 &&
                  cobrandingData.includeAddressLine2 && (
                    <div>{cobrandingData.addressLine2}</div>
                  )}
                {cobrandingData.city &&
                  cobrandingData.state &&
                  cobrandingData.zipcode &&
                  cobrandingData.includeCityStateZipcode && (
                    <div>{`${cobrandingData.city} ${cobrandingData.state} ${cobrandingData.zipcode}`}</div>
                  )}

                {((cobrandingData.phone && cobrandingData.includePhone) ||
                  (cobrandingData.email && cobrandingData.includeEmail)) && (
                  <div className={theme['contact-info']}>
                    {cobrandingData.phone && (
                      <span className={theme['phone']}>
                        {cobrandingData.phone}
                      </span>
                    )}
                    {cobrandingData.phone && cobrandingData.email && (
                      <span className={theme['separator']}>|</span>
                    )}
                    {cobrandingData.email && (
                      <span
                        className={theme['email']}
                        data-hc-name="cobrand-email-text"
                      >
                        {cobrandingData.email}
                      </span>
                    )}
                  </div>
                )}

                {cobrandingData.websiteUrl && cobrandingData.includeWebsite && (
                  <div>{cobrandingData.websiteUrl}</div>
                )}
                {cobrandingData.licenseNumber &&
                  cobrandingData.includeLicenseNumber && (
                    <div>
                      <span>
                        License Number: {cobrandingData.licenseNumber}
                      </span>
                    </div>
                  )}
              </div>
            )}
          </div>
          <div className={classNames(theme['section'], 'text-align-right')}>
            {cobrandingData.includeCompanyLogo &&
              cobrandingData.includeCompanyLogo && (
                <img
                  className={theme['company-logo']}
                  src={cobrandingData.companyLogoUrl}
                />
              )}
          </div>
        </div>
      </div>
    );
  }
}

export default PropertyExplorerCobranding;
